/**
 * @file Configuration overrides for the client.
 */

/** @type {import('@verosource/myhealth-web/src/config/networkConfig').NetworkConfig} */

const backendBaseUrl =
  "https://myhealth1.dev.myhealth.gnb-doh.vsfcloud.com/myhealth-gateway";

const networkConfig = {
  patientDataUrl: `${backendBaseUrl}/v3/patient/`,
  dependentDataUrl: `${backendBaseUrl}/v3/delegatedAccess/dependents/`,
  patientSummaryUrl: `${backendBaseUrl}/v1/patient-summary/`,
  patientSummaryManifestUrl: `${backendBaseUrl}/v1/patient-summary/manifest/`,
  patientSummaryRevokeUrl: `${backendBaseUrl}/v1/patient-summary/manifest/revoke-access`,
  patientSummaryViewerUrl: 'https://myhealth-ps-viewer1.dev.myhealth.gnb-doh.vsfcloud.com/',
  refreshTokenUrl: `${backendBaseUrl}/v3/authentication/refresh/`,
  medicationUrl: `${backendBaseUrl}/v3/medication/`,
  immunizationUrl: `${backendBaseUrl}/v3/immunization/`,
  observationUrl: `${backendBaseUrl}/v3/diagnosticReport/`,
  imagingUrl: `${backendBaseUrl}/v3/diagnosticImagingReport/`,
  encounterUrl: `${backendBaseUrl}/v3/encounter/`,
  loginUrl: `${backendBaseUrl}/v1/authentication/login`,
  messagingUrl: `${backendBaseUrl}/v1/messaging/`,
  loginProviderType: 'myhealth_broker_dev1',
  redirectUri: 'https://myhealth-web1.dev.myhealth.gnb-doh.vsfcloud.com/',
};

export default networkConfig;
